/* Adds previous/next arrows to Horizon's existing zoom-dialog component. */
(function () {
  'use strict';
  const icon = (left) => `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${left ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6'}" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  function init(root) {
    root.querySelectorAll('zoom-dialog').forEach(component => {
      if (component.dataset.customZoomReady === 'true') return;
      const dialog = component.querySelector('.dialog-zoomed-gallery__dialog');
      if (!dialog || component.querySelectorAll('.dialog-thumbnails-list__thumbnail').length < 2) return;
      component.dataset.customZoomReady = 'true';
      [['prev', 'Previous image', 'previous'], ['next', 'Next image', 'next']].forEach(([name, label, method]) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `custom-zoom-arrow custom-zoom-${name}`;
        button.setAttribute('aria-label', label);
        button.innerHTML = icon(name === 'prev');
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          if (typeof component[method] === 'function') component[method]();
        });
        dialog.appendChild(button);
      });
    });
  }
  const run = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();